export function deepCopy(data: any): any {
    if (data === undefined) return undefined;
    if (data === null) return null;
    return JSON.parse(JSON.stringify(data));
}
